import { lightTheme } from "../../theme/theme";
type Theme = typeof lightTheme;

export const ContactFormStyles = (theme: Theme, isMobile: boolean) => ({
  box: {
    margin: "0 auto",
    maxWidth: isMobile ? "90%" : "clamp(320px, 80vw, 540px)",
    padding: isMobile ? "18px" : "clamp(14px, 4.5vw, 24px)",
    marginTop: isMobile ? 20 : 0,
    width: "100%",
    borderRadius: 16,
    border: `1px solid ${theme.primary}22`,
    background: theme.card ?? "#fff",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column" as const,
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    transition:
      "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
    textDecoration: "none",
    color: theme.text,
    alignSelf: "center",
  },

  title: {
    fontSize: "clamp(22px, 5vw, 38px)",
    lineHeight: 1.2,
    marginBottom: "18px",
    marginTop: "0",
    marginInlineEnd: 20,
    fontFamily: '"Playfair Display", Georgia, serif',
    fontWeight: 600,
    fontStyle: "italic",
    color: theme.color4,
    textAlign: "center" as const,
    opacity: "0.95",
  },

  grid: (cols: 1 | 2) => ({
    display: "grid",
    gridTemplateColumns: cols === 1 ? "1fr" : "repeat(2, minmax(0, 1fr))",
    gap: cols === 1 ? 12 : 16,
  }),

  cell: {
    display: "flex",
    flexDirection: "column" as const,
  },

  fullRow: {
    gridColumn: "1 / -1",
  },

  btnRow: {
    marginTop: 14,
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "flex-start",
  },
  btn: {
    textDecoration: "none",
    backgroundColor: theme.color5,
    color: theme.text3,
    padding: "10px 20px",
    border: "none",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 700,
    fontSize: 16,
    cursor: "pointer",
    transition: "all 0.3s ease",
    opacity: 0.95,
  },

  btnHover: {
    backgroundColor: theme.primary,
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    transform: "translateY(-2px)",
  },
});
